module.exports = __webpack_public_path__ + "assets/milk-logo.414cb0bf.svg";